export const config = {
  all: {
    env: process.env.NODE_ENV || "development",
    isDev: process.env.NODE_ENV !== "production",
    basename: process.env.PUBLIC_PATH || "/",
    baseApi: process.env.REACT_APP_BASE_API || "",
    isBrowser: typeof window !== "undefined",
    drawerWidth: 292,
    drawerOpen: true,
    cardHeight: 233,
    rowsPerPage: 10,
    turnstileSiteKey: process.env.REACT_APP_CLOUDFLARE_TURNSTILE_SITE_KEY,
    currencyDecimalScale: 2,
    loginEcpf: {
      id: "11807",
      name: "consignet-v3",
      formAction:
        "https://autenticador.certisign.com.br/CertisignLogin/certificado/login",
      urlRetorno: `${process.env.REACT_APP_BASE_API}/api/authentication/e-cpf/certisign`,
    },
    validateEnvironment: process.env.REACT_APP_VALIDATE_ENVIRONMENT,
    validateEnvironmentNumber:
      process.env.REACT_APP_VALIDATE_ENVIRONMENT_NUMBER,
  },
  test: {
    isDev: false,
  },
  development: {},
  production: {},
};
